import store from '@/store';
import { p2pActions } from '@/store/p2p-slice';

import { concatenateChunks, decryptWithPrivateKey } from './P2PHelper';

export const p2pSendSuccessHandler = async data => {
    try {
        const { encrypted_key } = data;

        const p2pPrivateKey = store.getState().p2pReducer.p2pKeys;

        const decryptedChunks = [];

        for (const chunk of JSON.parse(encrypted_key)) {
            const decryptedChunk = await decryptWithPrivateKey(
                chunk,
                p2pPrivateKey.JSON_USER,
            );
            decryptedChunks.push(decryptedChunk);
        }

        const decryptedMessage = concatenateChunks(decryptedChunks);
        const keys = JSON.parse(decryptedMessage);
        store.dispatch(p2pActions.updateP2PKeys(keys));
        store.dispatch(p2pActions.updateIsInKeyUpload(false));
    } catch (e) {
        console.error('Error in decrypt key', e);
    }
};
